<form (ngSubmit)="handleSubmit()" class="lg:px-2 space-y-4 pb-3">
  <!-- Title -->
  <div class="space-y-1">
    <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
      <i class="pi pi-file text-xs"></i>
      {{ 'planner.taskForm.title' | transloco }}
    </label>
    <input type="text" [(ngModel)]="task.title" name="title"
      class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
      [placeholder]="'planner.taskForm.enterTaskTitle' | transloco" />
  </div>

  <!-- Description -->
  <div class="space-y-1">
    <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
      <i class="pi pi-align-left rtl-flip text-xs"></i>
      {{ 'planner.taskForm.description' | transloco }}
    </label>
    <textarea [(ngModel)]="task.description" name="description" rows="3"
      class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition resize-none placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
      [placeholder]="'planner.taskForm.describeTask' | transloco"></textarea>
  </div>

  <!-- Status -->
  <div class="space-y-1">
    <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
      style="width: fit-content">
      <i class="pi pi-hourglass text-xs"></i>
      {{ 'planner.taskForm.status' | transloco }}
    </label>
    <div class="inline-flex rounded-md border border-neutral-300 dark:border-neutral-800 overflow-hidden">
      <button type="button" (click)="task.status = 'pending'" [ngClass]="{
          'bg-amber-500 text-white': task.status === 'pending',
          'bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-600 ':
            task.status !== 'pending',
        }" class="px-3 py-1.5 text-xs font-medium flex items-center justify-center gap-1.5 transition">
        <i class="pi pi-circle" style="font-size: 10px"></i>
        {{ 'planner.taskForm.pending' | transloco }}
      </button>
      <button type="button" (click)="task.status = 'in_progress'" [ngClass]="{
          'bg-blue-500 text-white': task.status === 'in_progress',
          'bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-600':
            task.status !== 'in_progress',
        }"
        class="px-3 py-1.5 text-xs font-medium flex items-center justify-center gap-1.5 border-s border-neutral-300 dark:border-neutral-800 transition">
        <i class="pi pi-spinner" style="font-size: 10px"></i>
        {{ 'planner.taskForm.inProgress' | transloco }}
      </button>
      <button type="button" (click)="task.status = 'completed'" [ngClass]="{
          'bg-green-500 text-white': task.status === 'completed',
          'bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-600':
            task.status !== 'completed',
        }"
        class="px-3 py-1.5 text-xs font-medium flex items-center justify-center gap-1.5 border-s border-neutral-300 dark:border-neutral-800 transition">
        <i class="pi pi-check" style="font-size: 10px"></i>
        {{ 'planner.taskForm.completed' | transloco }}
      </button>
      <button type="button" (click)="task.status = 'cancelled'" [ngClass]="{
          'bg-red-500 text-white': task.status === 'cancelled',
          'bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-600':
            task.status !== 'cancelled',
        }"
        class="px-3 py-1.5 text-xs font-medium flex items-center justify-center gap-1.5 border-s border-neutral-300 dark:border-neutral-800 transition">
        <i class="pi pi-times" style="font-size: 10px"></i>
        {{ 'planner.taskForm.cancelled' | transloco }}
      </button>
    </div>
  </div>

  <!-- Priority -->
  <div class="space-y-1">
    <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
      <i class="pi pi-flag text-xs"></i>
      {{ 'planner.taskForm.priority' | transloco }}
    </label>
    <div class="inline-flex rounded-md border border-neutral-300 dark:border-neutral-800 overflow-hidden">
      <button type="button" (click)="task.priority = 'low'" [ngClass]="{
          'bg-green-500 text-white': task.priority === 'low',
          'bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-600':
            task.priority !== 'low',
        }" class="flex-1 px-3 py-1.5 text-xs font-medium flex items-center justify-center gap-1.5 transition">
        <i class="pi pi-arrow-down" style="font-size: 10px"></i>
        {{ 'planner.taskForm.low' | transloco }}
      </button>
      <button type="button" (click)="task.priority = 'medium'" [ngClass]="{
          'bg-orange-500 text-white': task.priority === 'medium',
          'bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-600':
            task.priority !== 'medium',
        }"
        class="flex-1 px-3 py-1.5 text-xs font-medium flex items-center justify-center gap-1.5 border-s border-neutral-300 dark:border-neutral-800 transition">
        <i class="pi pi-minus" style="font-size: 10px"></i>
        {{ 'planner.taskForm.medium' | transloco }}
      </button>
      <button type="button" (click)="task.priority = 'high'" [ngClass]="{
          'bg-red-500 text-white': task.priority === 'high',
          'bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-600':
            task.priority !== 'high',
        }"
        class="flex-1 px-3 py-1.5 text-xs font-medium flex items-center justify-center gap-1.5 border-s border-neutral-300 dark:border-neutral-800 transition">
        <i class="pi pi-arrow-up" style="font-size: 10px"></i>
        {{ 'planner.taskForm.high' | transloco }}
      </button>
    </div>
  </div>

  <!-- Date & Due Date Row -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="space-y-1">
      <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
        <i class="pi pi-calendar text-xs"></i>
        {{ 'planner.taskForm.startDate' | transloco }}
      </label>
      <input type="date" [(ngModel)]="task.date" name="date"
        class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition" />
    </div>

    <div class="space-y-1">
      <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
        <i class="pi pi-calendar text-xs"></i>
        {{ 'planner.taskForm.dueDate' | transloco }}
      </label>
      <input type="date" [(ngModel)]="task.due_date" name="due_date"
        class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition" />
    </div>
  </div>

  <!-- Spent Time -->
  <div class="space-y-1">
    <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
      <i class="pi pi-clock text-xs"></i>
      {{ 'planner.taskForm.spentTime' | transloco }}
    </label>
    <input type="text" [(ngModel)]="task.spent_time" name="spent_time"
      class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
      [placeholder]="'planner.taskForm.spentTimePlaceholder' | transloco" />
  </div>

  <!-- Tags -->
  <div class="space-y-1">
    <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
      <i class="pi pi-tag text-xs"></i>
      {{ 'planner.taskForm.tags' | transloco }}
    </label>
    <div class="flex gap-2 items-center">
      <input type="text" [(ngModel)]="newTag" name="newTag" (keypress)="onKeyPress($event, addTag)"
        class="flex-1 px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
        [placeholder]="'planner.taskForm.addTag' | transloco" />
      <button type="button" (click)="addTag()"
        class="bg-primary-500 text-white rounded-md hover:bg-primary-600 dark:hover:bg-primary-500 transition w-8 h-8 flex items-center justify-center">
        <i class="pi pi-plus text-xs"></i>
      </button>
    </div>
    @if (task.tags && task.tags.length > 0) {
      <div class="flex flex-wrap gap-1.5 mt-2">
        @for (tag of task.tags; track $index; let i = $index) {
          <span
            class="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded text-sm">
            {{ tag }}
            <button type="button" (click)="removeTag(tag)"
              class="hover:text-blue-900 dark:hover:text-blue-200 transition cursor-pointer">
              <i class="pi pi-times" style="font-size: 10px"></i>
            </button>
          </span>
        }
      </div>
    }
  </div>

  <!-- Report -->
  <div class="space-y-1">
    <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
      <i class="pi pi-file text-xs"></i>
      {{ 'planner.taskForm.report' | transloco }}
    </label>
    <textarea [(ngModel)]="task.report" name="report" rows="2"
      class="w-full px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition resize-none placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
      [placeholder]="'planner.taskForm.addProgressReport' | transloco"></textarea>
  </div>

  <!-- Comments -->
  <div class="space-y-1">
    <label class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300">
      <i class="pi pi-comment text-xs"></i>
      {{ 'planner.taskForm.comments' | transloco }}
    </label>
    <div class="flex gap-2 items-center">
      <input type="text" [(ngModel)]="newComment" name="newComment" (keypress)="onKeyPress($event, addComment)"
        class="flex-1 px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
        [placeholder]="'planner.taskForm.addComment' | transloco" />
      <button type="button" (click)="addComment()"
        class="bg-primary-500 text-white rounded-md hover:bg-primary-600 dark:hover:bg-primary-500 transition w-8 h-8 flex items-center justify-center">
        <i class="pi pi-plus text-xs"></i>
      </button>
    </div>
    @if (task.comments && task.comments.length > 0) {
      <div class="mt-2 space-y-1.5">
        @for (comment of task.comments; track $index; let i = $index) {
          <div
            class="px-3 py-2 bg-neutral-50 dark:bg-neutral-800/50 rounded-md text-xs text-neutral-700 dark:text-neutral-300 border border-neutral-200 dark:border-neutral-800">
            {{ comment }}
          </div>
        }
      </div>
    }
  </div>

  <!-- Submit Button -->
  <div class="pt-2">
    <button type="submit"
      class="w-full px-4 py-2 bg-primary-500 hover:bg-primary-600 dark:bg-primary-600 dark:hover:bg-primary-500 text-white rounded-md transition text-sm font-medium flex items-center justify-center gap-2 shadow-sm">
      <i class="pi pi-check-square w-4 h-4"></i>
      {{ 'planner.taskForm.createTask' | transloco }}
    </button>
  </div>
</form>